import {IncomingMessage} from 'http';
import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {EventPageVo} from '../../common/shared/api/gateway/event/EventPageVo.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {Maybe} from '../../graphql/generated/types';

/**
 * 이벤트 페이지 정보 조회
 *
 * Origin: pageNicolasApi.getEventInfo
 * API: POST /api/v1/store/event/web
 */
export async function postStoreEventWeb(
  {
    hashedEventId,
    target,
    isWebInApp,
    isMobile,
  }: {
    hashedEventId: string;
    target?: Maybe<string>;
    isWebInApp?: Maybe<boolean>;
    isMobile?: Maybe<boolean>;
  },
  options?: FetcherOptions & {ssrRequest?: IncomingMessage}
): Promise<ApiResultVo & EventPageVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/event/web',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: {
        hashedeventId: hashedEventId,
        ...(target && {target}),
        ...(isWebInApp !== undefined && {isWebInApp}),
        ...(isMobile !== undefined && {isMobile}),
      },
    },
    options
  );

  return response.data;
}
